import React from 'react';
import Message from './Message';

const MessageList = ({ messages, loading }) => {
  return (
    <div className="space-y-4">
      {messages.map((message, index) => (
        <Message
          key={index}
          message={message}
          isLastBotMessage={message.sender === "bot" && 
            index === messages.length - 1 && 
            loading}
        />
      ))}
    </div>
  );
};

export default MessageList;